import spark from './spark';
import trail from './trail';

export { spark, trail };


// WEBPACK FOOTER //
// ./src/components/ParticleSystem/emitters/index.ts